import Col from "@visa/vds/col";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import "flag-icon-css/css/flag-icon.min.css";
import { default as React, useContext, useState } from "react";
import {
  ButtonGroup,
  ButtonText,
  Fieldset,
  Form,
  Icon,
  InputMessage,
  InputMessageError,
  InputOption,
  RadioErrorMessage,
  Select,
} from "@visa/vds";
import FormControl from "@visa/vds/form-control";
import Input from "@visa/vds/input";
import "flag-icon-css/css/flag-icon.min.css";
import { useForm } from "react-hook-form";
import MCSControlInput from "components/MCSControlInput";
import { FormHelper } from "_helpers/FormHelper";
import { userService } from "services/user.service";
import { useAuthContextUser } from "context/AuthContext";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import { DEFAULT_COUNTRY_CODE, DEFAULT_COUNTRY_NAME } from "_constants/GlobalConstants";
import { trackPromise } from "react-promise-tracker";

const UserInfo = (props) => {
  const user = useAuthContextUser();
  const alertContext = useContext(GlobalAlertContext);
  const [disableResetButton, setDisableResetButton] = useState(true);
  const [originalData, setOriginalData] = useState(props.userData)

  const defaultValues = {
    userInfo: originalData,
    firstName: originalData.firstName,
    lastName: originalData.lastName,
    jobTitle: originalData.jobTitle,
    email: originalData.email,
    phone: originalData.phone
  }

  const {
    control,
    handleSubmit,
    setError,
    getValues,
    register,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const [formData, setFormData] = useState(getValues());
  
  const updateFormData = () => {
    setDisableResetButton(false);
    setFormData(getValues());
  }

  const onSubmit = () => {
    const updateUserDto = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      jobTitle: formData.jobTitle,
      phone: formData.phone
    }

    
    trackPromise(
      userService
      .UpdateUserInfo(user.id, updateUserDto)
      .then((result) => {
        if (result.status === 200) {
            setOriginalData(updateUserDto);
            alertContext.setSuccessMessage("User Information Update Success");
          } else {
            alertContext.setErrorMessage("User Information Failed");
          }
          setDisableResetButton(true);
        })
        .catch((error) => {
          alertContext.setErrorMessage("User Information Failed");
        })
    );
  };

  const onReset = () => {
    reset(originalData);
    setFormData(originalData)
    setDisableResetButton(true);
  }

  return (
    <>
      <Row>
        <Col>
          <Typography tag="h2">User Information</Typography>
          <Form>
            <Fieldset>
              <FormControl position="left" space="fifty">
                <MCSControlInput
                  label="First Name*"
                  register={register}
                  name="firstName"
                  control={control}
                  rules={{
                    required: true,
                    maxLength: 100,
                  }}
                  handleChange={updateFormData}
                />
              </FormControl>
              <FormControl position="left" space="fifty">
                <MCSControlInput
                  label="Last Name*"
                  name="lastName"
                  control={control}
                  rules={{
                    required: true,
                    maxLength: 100,
                  }}
                  handleChange={updateFormData}
                />
              </FormControl>
              <FormControl position="left" space="fifty">
                <MCSControlInput
                  label="Business Title"
                  name="jobTitle"
                  control={control}
                  rules={{
                    maxLength: 100,
                  }}
                  handleChange={updateFormData}
                />
              </FormControl>
              <FormControl position="left" space="fifty">
                <Input
                  label="Business Email"
                  name="email"
                  value={defaultValues.email}
                  readOnly
                />
              </FormControl>
              <FormControl position="left" space="fifty">
                <Input
                  label="Country"
                  name="country"
                  value={props.userData && props.userData.countryName != null ? props.userData.countryName : DEFAULT_COUNTRY_NAME}
                  readOnly
                />
              </FormControl>
              <FormControl position="left" space="fifty">
                <MCSControlInput
                  label="Business Phone Number"
                  name="phone"
                  control={control}
                  rules={{
                    maxLength: 100,
                  }}
                  handleChange={updateFormData}
                />
              </FormControl>
            </Fieldset>
          </Form>
        </Col>
      </Row>
      <Row>
        <Col></Col>
        <Col>
          <div style={{ display: "flex" }}>
            <ButtonGroup direction="right" style={{ marginLeft: "auto", marginRight: "5px" }}>
              <ButtonText
                name="accountInfoResetBtn"
                colorScheme="secondary"
                disabled={disableResetButton}
                onClick={onReset}
              >
                Reset
              </ButtonText>
            </ButtonGroup>
            <ButtonGroup direction="right">
              <ButtonText
                name="accountInfoSaveBtn"
                onClick={handleSubmit(onSubmit)}
              >
                Save
              </ButtonText>
            </ButtonGroup>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default UserInfo;
